import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi, StartScoreImprovementPlanResponse } from 'api/AICoachGoalsApi';

export const createStartScoreImprovementPlanThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk('yourGoal/startScoreImprovementPlan', async (applicationId: string, thunkApi) => {
    try {
      const response: StartScoreImprovementPlanResponse = await api.startScoreImprovementPlan(applicationId);
      return response;
    } catch (error: any) {
      const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
      return thunkApi.rejectWithValue(payload);
    }
  });
